import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterReport from 'views/customers/reports/betsReport/filterReport'; // Importing FilterReport component
import TableReport from 'views/customers/reports/betsReport/tableReport'; // Importing TableReport component
import TableTransactionsReport from 'views/customers/reports/betsReport/recordTransReport'; // Importing TableTransactionsReport component
import RecordReport from 'views/customers/reports/betsReport/recordReport'; // Importing RecordReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * BetsReportView class extending JetView to create a report view for bets.
 */
export default class BetsReportView extends JetView {
    /**
     * Configures the layout of the BetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme from app configuration

        // Right section of the layout containing reports
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordReport, TableTransactionsReport], // Rows containing report components
        };

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };

        // Left section of the layout containing filters and reports
        const left = {
            height: screen.width < 500 ? 500 : 0, // Responsive height based on screen width
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Apuestas'), // Label for the report title
                            width: 300,
                        },
                    ],
                },
                FilterReport, // Including the filter report component
                TableReport, // Including the table report component
                toolbar, // Including the toolbar for pagination
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main configuration for the BetsReportView
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the form
            view: 'form', // Form view type
            rows: [
                {
                    responsive: 'a5', // Responsive configuration
                    type: 'wide',
                    cols: [left, right], // Columns containing left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
